/**
 * ThreeToggle.js
 * Created by Vijay on 05/15/2020.
 */

import React, {useContext, useState, useEffect} from 'react';
import styled from 'styled-components';
import {actionIcCheckCircle24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import {DocumentTypeIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import {createUpdatePayloadForMultiSelectBody, createRequestURL} from '../Common/BodyResponseUtility';
import {formBodyType} from '../../../../../util/uiconstants';
import EllipsesControl from '../../../../Common/EllipsesControl/EllipsesControl';
import BodyKnowledgeDescription from '../BodyKnowledgeDescription';
import RiskFactorContainer from '../Common/RiskFactorContainer';
import uuidv4 from 'uuid/v4';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';
import Icon from '../../../BaseComponentWrappers/MotifIcon';
import ContentSwitcher from '../../../BaseComponentWrappers/MotifContentSwitcher';
import Button from '../../../BaseComponentWrappers/MotifButton';
import _ from 'lodash';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';

export default function ThreeToggle(props) {
	const {
		isAresView,
		showGuidance,
		guidanceFilter,
		options,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView
	} = props;

	const [threeToggleBodyData, setThreeToggleBodyData] = useState([]);

	const engagementId = useEngagementId(),
		documentTypeId = useContext(DocumentTypeIdContext),
		documentId = useDocumentId();

	const formBodyBorder = GetCardTypeForBody(options, isAresView);
	
	const motifActiveClass = 'motif-active';

	const getSelectedOption = (data) => {
		if (isSnapshotView) {
			return data.bodySelectedOptionId > 0 ? `${motifActiveClass} disabled` : '';
		}
		return data.bodyOptionId === data.bodySelectedOptionId ? motifActiveClass : '';
	};

	const toggleClick = (e) => {
		let firstToggle = options.optionsAndResponses[0].bodyOptionId.toString(),
			secondToggle = options.optionsAndResponses[1].bodyOptionId.toString(),
			thirdToggle = options.optionsAndResponses[2].bodyOptionId.toString(),
			selectedId = e.currentTarget.id,
			inputElement = document.getElementById(selectedId),
			boolResult = inputElement.classList.contains(motifActiveClass);

		if (firstToggle === selectedId) {
			if (!boolResult) {
				inputElement.classList.add(motifActiveClass);
			} else {
				inputElement.classList.remove(motifActiveClass);
			}
			document.getElementById(secondToggle).classList.remove(motifActiveClass);
			document.getElementById(thirdToggle).classList.remove(motifActiveClass);
		} else if (secondToggle === selectedId) {
			if (!boolResult) {
				inputElement.classList.add(motifActiveClass);
			} else {
				inputElement.classList.remove(motifActiveClass);
			}
			document.getElementById(firstToggle).classList.remove(motifActiveClass);
			document.getElementById(thirdToggle).classList.remove(motifActiveClass);
		} else if (thirdToggle === selectedId) {
			if (!boolResult) {
				inputElement.classList.add(motifActiveClass);
			} else {
				inputElement.classList.remove(motifActiveClass);
			}
			document.getElementById(firstToggle).classList.remove(motifActiveClass);
			document.getElementById(secondToggle).classList.remove(motifActiveClass);
		}
		// set Div disabled
		// document.getElementById(bodyId).classList.add('greyOutArea');

		if (threeToggleBodyData && threeToggleBodyData.length > 0) {
			threeToggleBodyData.map((data) => {
				if (data.bodyOptionId === data.bodySelectedOptionId && data.bodyOptionId !== Number(e.currentTarget.id)) {
					data.isChecked = !data.isChecked;
				} else if (data.bodyOptionId === Number(e.currentTarget.id)) {
					data.isChecked = !data.isChecked;
				}
			});
			setThreeToggleBodyData(threeToggleBodyData);
		}

		// Create body response
		const bodyResponseObject = createUpdatePayloadForMultiSelectBody(
			formBodyType.ToggleThreeButton,
			threeToggleBodyData
		);

		updateBodyOptions(
			bodyId,
			selectedId,
			createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
			bodyResponseObject
		);
	};

	useEffect(() => {
		let bodyData = _.cloneDeep(options.optionsAndResponses);

		if (bodyData && bodyData.length > 0) {
			let filterBodyData = bodyData.map((obj) => ({
				...obj,
				isChecked: obj.bodyOptionId === obj.bodySelectedOptionId
			}));
			setThreeToggleBodyData(filterBodyData);
		} else {
			setThreeToggleBodyData([]);
		}
	}, [options.optionsAndResponses]);

	return (
		<Wrapper className={`SectionBodyWrapper ${formBodyBorder}`}>
			{options.optionsAndResponses && options.optionsAndResponses.length > 0 && (
				<BodyKnowledgeDescription
					isAresView={isAresView}
					showGuidance={showGuidance}
					guidanceFilter={guidanceFilter}
					isSnapshotView={isSnapshotView}
					bodyModel={options}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={options.name}
					isCustom={options.isCustom}
					isDuplicate={options.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
				/>
			)}
			<section className="SectionBodyData ThreeToggleBody" id={bodyId}>
				{/* <section className="MotifProgressBarWrapper">
					<ProgressBar isIndeterminate showLabel labelComponent={<span>{labels.saving}</span>} />
				</section> */}
				<ContentSwitcher>
					{threeToggleBodyData &&
						threeToggleBodyData.map((data) => {
							return (
								<Button
									key={uuidv4()}
									name={data.id}
									onClick={toggleClick}
									id={data.bodyOptionId}
									type="button"
									className={`toggleButton ${getSelectedOption(data)}`}
									disabled={isSnapshotView}
								>
									<EllipsesControl content={data.bodyOptionText} tooltip={data.bodyOptionText} noOfLines={1} />
									{isAresView && <Icon src={actionIcCheckCircle24px} />}
								</Button>
							);
						})}
				</ContentSwitcher>
			</section>
			{threeToggleBodyData &&
				threeToggleBodyData.map((data) => {
					return (
						data.isChecked &&
						data.riskFactorList.length > 0 && (
							<RiskFactorContainer
								riskFactors={data.riskFactorList}
								isVisible
								sectionId={sectionId}
								bodyId={bodyId}
								isViewBodyOnly={false}
							/>
						)
					);
				})}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	.SectionBodyData {
		flex-direction: unset !important;
		margin: var(--px-20) 0;
		position: relative;
		min-width: var(--px-750);
		max-width: var(--px-950);
		/* .MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 80%;
			height: 100%;
			.motif-progress-bar-wrapper {
				height: 100%;
				width: 30%;
				z-index: 1;
				justify-content: center;
			}
		} */
		/* &.greyOutArea {
			.RiskFactorContainer {
				.MotifProgressBarWrapper {
					display: none !important;
				}
			}
		} */
	}
	.toggleButton {
		height: var(--px-45);
		min-width: var(--px-200);
		max-width: var(--px-300);
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: inherit !important;
		.ellipses {
			justify-content: center;
		}
	}
	.RiskFactorContainer {
		margin: 0 0 var(--px-20) var(--px-10) !important;
	}
`;
